import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';

export const useThirdPersonCopy = () => {
  const [state] = useProductDetailsPageContext();
  const shouldUseThirdPersonCopy = state.isAuthenticatedClient === false;
  const clientName = state.clientName;

  const getTranslationContext = (): string | undefined =>
    shouldUseThirdPersonCopy ? 'thirdPerson' : undefined;

  const translationContext = getTranslationContext();

  return {
    shouldUseThirdPersonCopy,
    translationContext,
    clientName,
  };
};
